import { render, staticRenderFns } from "./UIDatePicker2.vue?vue&type=template&id=6bb34a06&scoped=true"
import script from "./UIDatePicker2.vue?vue&type=script&lang=js"
export * from "./UIDatePicker2.vue?vue&type=script&lang=js"
import style0 from "./UIDatePicker2.vue?vue&type=style&index=0&id=6bb34a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb34a06",
  null
  
)

export default component.exports